import React, { Component } from 'react';
import bankNotice from './notice';
import lang from '../../../lang';

class BankSuccess extends Component {
    static defaultPorps = {
        product: null,
        accountId: '',
        orderBank: '',
        onClose: function(){}
    }

    onClose(){
        this.props.onClose();
    }

    popUpNotice = ()=>{
        bankNotice.create();
    }
    
    render() {
        let product = this.props.product || {};

        return (
            <div className="bank-pop bank-result-pop">
                <div className="bank-pop-hd">
                    <h2>{lang.template('匯款帳號訊息')}</h2>
                    <div className="close" onClick={this.onClose.bind(this)}>x</div>
                </div>
                <div className="bank-pop-bd">
                    <div className="content">
                        <h3>{status}</h3>
                        <div className="bank-info">
                            <ul>
                                <li>
                                    <label>{lang.template('銀行代碼')}</label>
                                    <span className="info">807</span>
                                </li>
                                <li>
                                    <label>{lang.template('銀行名稱')}</label>
                                    <span className="info">{this.props.orderBank}</span>
                                </li>
                                <li>
                                    <label>{lang.template('戶名')}</label>
                                    <span className="info">{lang.template('網易收服務ATM專戶')}</span>
                                </li>
                                <li>
                                    <label>{lang.template('匯款帳號')}</label>
                                    <span className="info">{this.props.accountId}</span>
                                </li>
                                <li>
                                    <label>{lang.template('匯款金額')}</label>
                                    <span className="info">{product.currencySymbol}{product.money /100}</span>
                                </li>
                            </ul>
                        </div>
                        <div className="notice">{lang.template('請您於24小時內通過線下銀行匯款的方式轉帳至上述銀行帳戶，逾期將無法付款成功')}</div>
                    </div>
                </div>

                <div className="bank-pop-ft">
                    <div className="btn" onClick={this.onClose.bind(this)}>{lang.template('確定')}</div>
                    <p className="notice-title" onClick={this.popUpNotice}>{lang.template('匯款注意事項')}</p>
                </div>
            </div>
        );
    }
}

export default BankSuccess;


// WEBPACK FOOTER //
// ./js/component/recharge/bank/result.js